import { mapShowInfoToUpdateShowInternalInstruction, mapShowToShowInfo, ShowInfo } from "show/edit/utils";

export { mapShowToShowInfo as convertToFormState };
export type { ShowInfo };

export const getInstructionForInternal = (
  showId: number,
  showInfo: ShowInfo,
  partial?: Partial<Omit<server.dto.UpdateShowInternalEnvironmentInstruction, "showId">>
): server.dto.UpdateShowInternalEnvironmentInstruction => ({
  showId,
  ...mapShowInfoToUpdateShowInternalInstruction(showInfo, showInfo.production),
  ...partial,
});

export const getInstructionForExternal = (
  showId: number,
  showInfo: ShowInfo,
  partial?: Partial<Omit<server.dto.UpdateShowExternalEnvironmentInstruction, "showId">>
): server.dto.UpdateShowExternalEnvironmentInstruction => ({
  showId,
  dateTime: {
    startDisplay: showInfo.showDates.startDisplayDate.toDate(),
    endDisplay: showInfo.showDates.endDisplayDate.toDate(),
    customFallbackTime: showInfo.showDates.timeOfPerformance,
    mode: showInfo.showDates.mode,
  },
  eventName: showInfo.eventName,
  eventWebsite: showInfo.eventWebsite,
  productionId: showInfo.production?.productionId,
  statusId: showInfo.status?.statusId,
  ...partial,
});
